import React, { useState } from "react";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import WorkshopCapacityOverviewTab from "./components/workshop/WorkshopCapacityOverviewTab";
import WorkshopCapacityPlanTab from "./components/workshop/WorkshopCapacityPlanTab";
import WorkshopCapacityHistoryTab from "./components/workshop/WorkshopCapacityHistoryTab";
import WorkshopOmsetningWeekTab from "./components/workshop/WorkshopOmsetningWeekTab";
import WorkshopOmsetningMonthTab from "./components/workshop/WorkshopOmsetningMonthTab";
import WorkshopOmsetningHistoryTab from "./components/workshop/WorkshopOmsetningHistoryTab";
import WorkshopMaanedsoversiktTab from "./components/workshop/WorkshopMaanedsoversiktTab";
import WorkshopDelerHistoryTab from "./components/workshop/WorkshopDelerHistoryTab";
import WorkshopDelerListeTab from "./components/workshop/WorkshopDelerListeTab";
import WorkshopSalgsrapportTab from "./components/workshop/WorkshopSalgsrapportTab";
import WorkshopSendingerTab from "./components/workshop/WorkshopSendingerTab";
import WorkshopLonnskostTab from "./components/workshop/WorkshopLonnskostTab";
import { normalizeWorkshopSlug } from "./components/workshop/workshopCapacityUtils";

export default function WorkshopCapacityStats() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [storeSlug, setStoreSlug] = useState(
    () => normalizeWorkshopSlug(Cookies.get("selectedStore") || "") || "sport1royken"
  );
  const [weeksAhead, setWeeksAhead] = useState(8);
  const [section, setSection] = useState(() => {
    const fraUrl = searchParams.get("tab");
    return ["arbeid", "deler", "salgsrapport", "sendinger", "fasteUtgifter"].includes(fraUrl) ? fraUrl : "arbeid";
  });
  const [activeTab, setActiveTab] = useState("overview");
  const [delerTab, setDelerTab] = useState("delerOmsetning");
  const [fasteUtgifterTab, setFasteUtgifterTab] = useState("lonnskost");

  return (
    <div className="max-w-7xl mx-auto p-6 bg-white rounded-lg shadow">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <h2 className="text-2xl font-semibold">Verkstedstatistikk</h2>
        <button
          onClick={() => navigate("/workshop")}
          className="px-3 py-2 rounded bg-gray-200 hover:bg-gray-300"
        >
          Tilbake
        </button>
      </div>

      {/* Hovedseksjoner */}
      <div className="flex flex-wrap gap-2 mb-6">
        <button
          onClick={() => setSection("arbeid")}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold ${
            section === "arbeid"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
          }`}
        >
          Arbeid
        </button>

        <button
          onClick={() => setSection("deler")}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold ${
            section === "deler"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
          }`}
        >
          Deler
        </button>

        <button
          onClick={() => setSection("salgsrapport")}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold ${
            section === "salgsrapport"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
          }`}
        >
          Salgsrapport verksted
        </button>

        <button
          onClick={() => setSection("sendinger")}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold ${
            section === "sendinger"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
          }`}
        >
          Sendinger
        </button>

        <button
          onClick={() => setSection("fasteUtgifter")}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold ${
            section === "fasteUtgifter"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
          }`}
        >
          Faste utgifter
        </button>
      </div>

      {section === "arbeid" && (
        <div className="grid md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm text-gray-600 mb-1">Verksted</label>
            <select
              value={storeSlug}
              onChange={(e) => setStoreSlug(normalizeWorkshopSlug(e.target.value))}
              className="w-full border rounded p-2"
            >
              <option value="alle">Alle verksteder</option>
              <option value="sport1royken">Sport 1 Røyken</option>
              <option value="sport1slemmestad">Sport 1 Slemmestad</option>
              <option value="roykensykkelverksted">Røyken Sykkelverksted</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Antall uker
            </label>
            <select
              value={weeksAhead}
              onChange={(e) => setWeeksAhead(Number(e.target.value))}
              className="w-full border rounded p-2"
            >
              <option value={4}>4 uker</option>
              <option value={8}>8 uker</option>
              <option value={12}>12 uker</option>
              <option value={16}>16 uker</option>
            </select>
          </div>
        </div>
      )}

      {section === "arbeid" && (
      <div className="flex flex-wrap gap-2 mb-6 border-b pb-3">
        <button
          onClick={() => setActiveTab("overview")}
          className={`px-4 py-2 rounded ${
            activeTab === "overview"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Oversikt
        </button>

        <button
          onClick={() => setActiveTab("plan")}
          className={`px-4 py-2 rounded ${
            activeTab === "plan"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Planlagt kapasitet
        </button>

        <button
          onClick={() => setActiveTab("history")}
          className={`px-4 py-2 rounded ${
            activeTab === "history"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Historikk
        </button>

        <button
          onClick={() => setActiveTab("omsetningUke")}
          className={`px-4 py-2 rounded ${
            activeTab === "omsetningUke"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Omsetning denne uken
        </button>

        <button
          onClick={() => setActiveTab("omsetningMnd")}
          className={`px-4 py-2 rounded ${
            activeTab === "omsetningMnd"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Omsetning denne mnd.
        </button>

        <button
          onClick={() => setActiveTab("omsetning")}
          className={`px-4 py-2 rounded ${
            activeTab === "omsetning"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Omsetning historikk
        </button>

        <button
          onClick={() => setActiveTab("maanedsoversikt")}
          className={`px-4 py-2 rounded ${
            activeTab === "maanedsoversikt"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Faktureringsgrunnlag
        </button>
      </div>
      )}

      {section === "deler" && (
      <div className="flex flex-wrap gap-2 mb-6 border-b pb-3">
        <button
          onClick={() => setDelerTab("delerOmsetning")}
          className={`px-4 py-2 rounded ${
            delerTab === "delerOmsetning"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Deler og tilbehør
        </button>

        <button
          onClick={() => setDelerTab("delerListe")}
          className={`px-4 py-2 rounded ${
            delerTab === "delerListe"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Deler-liste
        </button>
      </div>
      )}

      {section === "arbeid" && activeTab === "overview" && (
        <WorkshopCapacityOverviewTab
          storeSlug={storeSlug}
          weeksAhead={weeksAhead}
        />
      )}

      {section === "arbeid" && activeTab === "plan" && (
        <WorkshopCapacityPlanTab
          storeSlug={storeSlug}
          weeksAhead={weeksAhead}
        />
      )}

      {section === "arbeid" && activeTab === "history" && (
        <WorkshopCapacityHistoryTab
          storeSlug={storeSlug}
          weeksBack={weeksAhead}
        />
      )}

      {section === "arbeid" && activeTab === "omsetningUke" && (
        <WorkshopOmsetningWeekTab storeSlug={storeSlug} />
      )}

      {section === "arbeid" && activeTab === "omsetningMnd" && (
        <WorkshopOmsetningMonthTab storeSlug={storeSlug} />
      )}

      {section === "arbeid" && activeTab === "omsetning" && (
        <WorkshopOmsetningHistoryTab storeSlug={storeSlug} />
      )}

      {section === "arbeid" && activeTab === "maanedsoversikt" && (
        <WorkshopMaanedsoversiktTab />
      )}

      {section === "deler" && delerTab === "delerOmsetning" && (
        <WorkshopDelerHistoryTab />
      )}

      {section === "deler" && delerTab === "delerListe" && (
        <WorkshopDelerListeTab />
      )}

      {section === "salgsrapport" && <WorkshopSalgsrapportTab />}

      {section === "sendinger" && <WorkshopSendingerTab />}

      {section === "fasteUtgifter" && (
      <div className="flex flex-wrap gap-2 mb-6 border-b pb-3">
        <button
          onClick={() => setFasteUtgifterTab("lonnskost")}
          className={`px-4 py-2 rounded ${
            fasteUtgifterTab === "lonnskost"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Lønnskost
        </button>
      </div>
      )}

      {section === "fasteUtgifter" && fasteUtgifterTab === "lonnskost" && <WorkshopLonnskostTab />}
    </div>
  );
}